// extracted by mini-css-extract-plugin
export default {"rootoutlet":"Rooutlayout_rootoutlet__xjovO"};